
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import React, { Component } from "react";
import DatePicker from "react-datepicker";
import banner from '../pics/banner.PNG';
import { FaWhatsapp } from 'react-icons/fa';
import About from '../About/About';
import { isLoggedIn } from '../Utils/Utils';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import maleIcon from '../pics/maleProfileIcon.png';
import femaleIcon from '../pics/femaleProfileIcon.png';
import { LoadingPage } from '../Loadingpage/Loadingpage';
import { LayoutDashboard, Menu } from 'lucide-react';
import { getAllCustomerOrders, getOrderStatuses, getAllOrderStatuses, formatDate } from '../Utils/Utils';
import { ArrowLeft } from 'react-bootstrap-icons';
import { BsPencil } from 'react-icons/bs';
//import { redirect } from 'next/dist/server/api-utils';
class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.handleLogOutOpen = React.createRef()
        this.handleAboutOpen = React.createRef();
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            shouldRedirect: false,
            fullname: "",
            emailaddress: "",
            phonenumber: "",
            area: "",
            token: "",
            role: "",
            address: "",
            city: "",
            userid: "",
            gender: "",
            pendingCount: 0,
            completedCount: 0,
            processingCount: 0,
            readyToCollectCount: 0,
            customerOrders: [],
            orderStatuses: [],
            customerPendingOrders: [],
            processingOrders: [],
            completedOrders:[],
            readyOrders: [],
            isLoading: true,
            initials: this.props.location.state && this.props.location.state.fullname ? this.props.location.state.fullname.split(" ").map(name => name.charAt(0)).join("") : ""
        }
    }

    componentDidMount = async () => {

        const [customerOrders, orderStatuses] = await Promise.all([
            getAllCustomerOrders(),
            getAllOrderStatuses()
        ]);
        this.setState({ isLoading: false });

        // Calculate pending orders
        let pendingCount = 0;
        let pendingOrders = []
        for (let i = 0; i < customerOrders.length; i++) {
            let foundMatch = false;
            for (let j = 0; j < orderStatuses.length; j++) {

                if (customerOrders[i].id === orderStatuses[j].orderid) {
                    foundMatch = true;
                    break;
                }
            }
            if (!foundMatch) {
                pendingCount++;
                pendingOrders.push(customerOrders[i]);
            }
            this.setState({ customerPendingOrders: pendingOrders, orderStatuses: orderStatuses, pendingCount: pendingCount });
        }

        // calculate completed orders
        let completedCount = 0;
        let completedOrders = []
        for (let i = 0; i < customerOrders.length; i++) {
            let foundMatch = false;
            for (let j = 0; j < orderStatuses.length; j++) {

                if ((customerOrders[i].id === orderStatuses[j].orderid) && ((orderStatuses[j].status === "Delivered") || (orderStatuses[j].status === "Collected"))) {
                    foundMatch = true;
                    break;
                }
            }
            if (foundMatch) {
                completedCount++;
                completedOrders.push(customerOrders[i])
            }
            this.setState({completedOrders: completedOrders, completedCount: completedCount });
        }
        
        // calculate processing orders
        let processingCount = 0;
        let processingOrders = []
        for (let i = 0; i < customerOrders.length; i++) {
            let foundMatch = false;
            for (let j = 0; j < orderStatuses.length; j++) {

                if ((customerOrders[i].id === orderStatuses[j].orderid) &&
                    ((orderStatuses[j].status === "Ready to collect") || (orderStatuses[j].status === "Delivered") || (orderStatuses[j].status === "Collected")
                        || (orderStatuses[j].status === "Cancelled"))) {
                    break;
                }
                else if ((customerOrders[i].id === orderStatuses[j].orderid) && (orderStatuses[j].status === "Processing")) {
                    foundMatch = true;
                }
            }
            if (foundMatch) {
                processingCount++;
                processingOrders.push(customerOrders[i])
            }
            this.setState({processingOrders: processingOrders, processingCount: processingCount });
        }

        // calculate Ready to collect orders
        let readyToCollectCount = 0;
        let readyOrders = []
        for (let i = 0; i < customerOrders.length; i++) {
            let foundMatch = false;
            for (let j = 0; j < orderStatuses.length; j++) {

                if ((customerOrders[i].id === orderStatuses[j].orderid) &&
                    ((orderStatuses[j].status === "In store") || (orderStatuses[j].status === "Processing")
                        || (orderStatuses[j].status === "Cancelled"))) {
                    break;
                }
                else if ((customerOrders[i].id === orderStatuses[j].orderid) && (orderStatuses[j].status === "Ready to collect")) {
                    foundMatch = true;
                    break;
                }
            }
            if (foundMatch) {
                readyToCollectCount++;
                readyOrders.push(customerOrders[i])
            }
            this.setState({readyOrders: readyOrders, readyToCollectCount: readyToCollectCount });
        }
        //this.getPendingOrders();

        if (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("token") === "") {
            this.setState({ shouldRedirect: true });
        }
        else {
            this.setState({
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress,
                phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role,
                address: this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city,
                userid: this.props.location.state.userid, gender: this.props.location.state.gender
            })
            if (!this.props.location.state.role.includes('Admin')) {
                this.props.navigate('/menu', {
                    state: {
                        fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress,
                        phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role,
                        address: this.props.location.state.address, area: this.props.location.state.area, gender: this.props.location.state.gender,
                    }
                });
                // document.getElementById('viewEditOrders').style.display = "block";
            }
        }
    }
    goBackToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/home', {
            state: {
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, gender: this.props.location.state.gender,
                phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role, address:
                    this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city, userid: this.props.location.state.userid
            }
        });
    }

    goToOrders = (dashboardOrderType, dashboardtype) => {    
        this.props.navigate('/orders', {
            state: {
                fullname: this.state.fullname, emailaddress: this.state.emailaddress, phonenumber: this.state.phonenumber, dashboardOrderType: dashboardOrderType,
                dashboardtype: dashboardtype,
                role: this.state.role, address: this.state.address, area: this.state.area, city: this.state.city, userid: this.state.userid, gender: this.state.gender
            }
        });
    }

    openAbout = () => {
        this.setState({ about: "about" });
        this.handleAboutOpen.current.handleAboutOpen();
    }

    render() {
        if (this.state.shouldRedirect === true || this.props.location.state === null || this.props.location.state === undefined) {
            return <Navigate to="/" replace />;
        }
        return (
            <>
                <div style={{
                    height: "100%", margin: "0", padding: "0", paddingLeft: "10px", paddingRight: "10px",
                    fontFamily:"lora"
                }}>
                    <div className='mainDivHome' style={{
                        paddingTop: "5vh", border: '2px solid white', borderRadius: "10px",
                        backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '250px'
                    }}>
                        <div style={{ paddingTop: "10px", paddingBottom: "10px", textAlign: "center", color: "white", fontSize: "25px", fontWeight: "bold", textShadow: "2px 2px 4px #000000" }}>
                            <span style={{ fontStyle: "italic" }}><label>iWash Laundry Solutions </label></span><br />
                            {/* <span style={{ fontStyle: "italic" }}><label>Welcome {(this.state.fullname).split(" ")[0]} </label></span><br /> */}
                            <span style={{ fontStyle: "italic" }}><label>{this.state.date}</label></span>
                        </div>
                    </div>
                    <div style={{ paddingTop: "8px", paddingBottom: "5px", textAlign: "center", color: "#0c0b07ff", width: "100%" }}>
                        <div style={{ width: "50%", float: "left" }}>
                            <span variant="primary" style={{
                                border: "none", color: "darkblue", fontSize: "18px", fontWeight: "bold", textShadow: "1px 1px 2px gray",
                                paddingTop: "2vh", height: "60px", paddingBottom: "1vh", display: "flex", width: "100%", borderRadius: "10px",
                            }} onClick={this.goBackToMenu}><label>
                                <ArrowLeft color="darkblue" size={40} /> Dashboard</label>
                            </span>
                        </div>
                        <div style={{ paddingLeft: '30%', width: '50%', top: '-1px', right: '-1px', overflow: 'hidden', position: 'relative', textAlign: "center" }}>
                            <img src={this.props.location.state.gender === 'Male' ? maleIcon : femaleIcon} alt="Profile"
                                style={{ borderRadius: '50%', width: '65px', height: '65px', border: '1px solid lightblue' }} />
                            <div style={{ position: 'absolute', top: '50%', left: '80%', transform: 'translate(-50%, -50%)' }}>
                                <span style={{ fontStyle: "italic", fontsize: "14px", color: "darkblue" }}>{this.state.initials}</span>
                            </div>
                        </div>
                    </div>
                    {this.state.isLoading ? (
                        <LoadingPage />
                    ) : (
                        <>
                            <div style={{ paddingTop: "0.5vh", paddingBottom: "0.5vh", borderRadius: "10px", display: "flex", gap: "1rm", fontSize:"18px" }}>
                                <Button style={{
                                    height: "160px", paddingLeft: "5px", width: "50%", border: '3px solid white', borderRadius: "35px",
                                    fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic",backgroundColor:"darkgreen"
                                }} text="" onClick={()=>this.goToOrders(this.state.completedOrders, 'COMPLETED')}><span style={{ fontWeight: "bold", color: "#c2fcca" }}>Completed Orders<br />{this.state.completedCount}</span></Button>
                                <Button style={{
                                    marginRight: "5px", height: "160px", paddingLeft: "5px", width: "50%", border: '3px solid white', backgroundColor: "silver",
                                    fontWeight: "bold", color: "#F5F5F5", fontSize: "18px", fontStyle: "italic", borderRadius: "35px"
                                }} text="" onClick={()=>this.goToOrders(this.state.customerPendingOrders, 'PENDING')}><span style={{ fontWeight: "bold", color: "#d46464" }}>Pending Orders<br />{this.state.pendingCount}</span>
                                </Button>
                            </div>
                            <div style={{ paddingTop: "0.5vh", paddingBottom: "0.5vh", borderRadius: "10px", display: "flex", gap: "1rm", fontSize:"18px" }}>
                                <Button style={{
                                    marginRight: "5px", height: "160px", paddingLeft: "5px", width: "50%", background: "none", border: '3px solid white',
                                    backgroundColor: "olive", fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic", borderRadius: "35px"
                                }} text="" onClick={()=>this.goToOrders(this.state.processingOrders, 'PROCESSING')}><span style={{ fontWeight: "bold", color: "#c2fcca" }}>Processing Orders<br />{this.state.processingCount}</span>
                                </Button>
                                <Button style={{
                                    height: "160px", paddingLeft: "5px", width: "50%", borderRadius: "35px", backgroundColor:"lightgreen",
                                    border: '3px solid white', fontWeight: "bold", color: "white", fontSize: "18px", fontStyle: "italic"
                                }} text="" onClick={()=>this.goToOrders(this.state.readyOrders, 'READY TO COLLECT')}><span style={{ fontWeight: "bold", color: "black" }}>Ready to Collect<br />{this.state.readyToCollectCount}</span></Button>
                            </div>
                        </>
                    )}

                    <div style={{ paddingTop: "1vh", fontSize: "15px" }}>
                        <div style={{
                            marginTop: "5%", borderTop: "1px solid #ccc", textAlign: "center", fontSize: "14px", color: "#666", height: "100%",
                            backgroundColor: "#f0eee4", border: "solid 0px #e8cf4f", borderRadius: "10px", paddingTop: "5px", paddingBottom: "20px"
                        }}>
                            <p>&copy; {new Date().getFullYear()} HudumaSoft. All rights reserved</p>
                            <div>
                                <Button style={{
                                    backgroundColor: "transparent", border: "none", color: "blue", fontSize: "16px", cursor: "pointer",
                                    fontWeight: "bold", textDecoration: "underline"
                                }}
                                    onClick={this.openAbout}>About Us
                                </Button>
                                | <a href="https://wa.me/+27796372245" rel="noopener noreferrer" target="_blank" title="Call or WhatsApp us!"> <FaWhatsapp size={35} color="#25D366" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
    }
}
export default withNavigateHook(Dashboard);